var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.375,
    height: 22.594
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bet-single_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bet-single_svg__Rectangle_1071",
    "data-name": "Rectangle 1071",
    fill: "none",
    d: "M0 0h18.375v22.594H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bet-single_svg__Icon_-_Bet_Single",
    "data-name": "Icon - Bet Single"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bet-single_svg__Group_2276",
    "data-name": "Group 2276",
    clipPath: "url(#bet-single_svg__clip-path)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "bet-single_svg__Path_5539",
    "data-name": "Path 5539",
    d: "M17.625 21.844V2.157A1.407 1.407 0 0016.219.75H2.156A1.407 1.407 0 00.75 2.157v19.687l4.812-2.813 3.625 2.813 3.626-2.813z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-single_svg__Path_5540",
    "data-name": "Path 5540",
    d: "M5.3 5.672a.352.352 0 110-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-single_svg__Path_5541",
    "data-name": "Path 5541",
    d: "M5.3 5.672a.352.352 0 100-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-single_svg__Line_956",
    "data-name": "Line 956",
    transform: "translate(8.915 5.32)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h4.836"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTguMzc1IiBoZWlnaHQ9IjIyLjU5NCIgdmlld0JveD0iMCAwIDE4LjM3NSAyMi41OTQiPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzEwNzEiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDEwNzEiIHdpZHRoPSIxOC4zNzUiIGhlaWdodD0iMjIuNTk0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSJub25lIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8ZyBpZD0iSWNvbl8tX0JldF9TaW5nbGUiIGRhdGEtbmFtZT0iSWNvbiAtIEJldCBTaW5nbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPgogICAgPGcgaWQ9Ikdyb3VwXzIyNzYiIGRhdGEtbmFtZT0iR3JvdXAgMjI3NiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtcGF0aCkiPgogICAgICA8cGF0aCBpZD0iUGF0aF81NTM5IiBkYXRhLW5hbWU9IlBhdGggNTUzOSIgZD0iTTE3LjYyNSwyMS44NDRWMi4xNTdBMS40MDcsMS40MDcsMCwwLDAsMTYuMjE5Ljc1SDIuMTU2QTEuNDA3LDEuNDA3LDAsMCwwLC43NSwyLjE1N1YyMS44NDRsNC44MTItMi44MTMsMy42MjUsMi44MTMsMy42MjYtMi44MTNaIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF81NTQwIiBkYXRhLW5hbWU9IlBhdGggNTU0MCIgZD0iTTUuMyw1LjY3MmEuMzUyLjM1MiwwLDEsMSwwLS43IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfNTU0MSIgZGF0YS1uYW1lPSJQYXRoIDU1NDEiIGQ9Ik01LjMsNS42NzJhLjM1Mi4zNTIsMCwxLDAsMC0uNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzk1NiIgZGF0YS1uYW1lPSJMaW5lIDk1NiIgeDI9IjQuODM2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjkxNSA1LjMyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgBetSingle as ReactComponent };